__webpack_require__.p = "/wp-content/themes/feg/assets/js/";